import { Component, Input } from "@angular/core";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { ToastrService } from "ngx-toastr";
import { CommonService } from "src/app/shareModule/services/common.service";
import { CustomerService } from "src/app/shareModule/services/customer.service";
import { environment } from "src/environments/environment";

@Component({
  selector: "add-product-section",
  templateUrl: "./add-product-section.component.html",
  styleUrl: "./add-product-section.component.scss",
})
export class ProductSectionComponent {
  @Input() productType: any = "";
  public productList: Array<any> = [];
  public selectedProduct: Array<any> = [];
  public imgUrl = environment.ImageUrl;

  constructor(private toastr: ToastrService, public modalService: NgbModal, private customerService: CustomerService, public commonService: CommonService) { }

  public openProductList(modal) {
    if (this.productType) {
      this.getMemberProductList(this.productType);
      this.modalService.open(modal, {
        size: "sm",
        ariaLabelledBy: "modal-basic-title",
        windowClass: "suggestion",
      });
    } else {
      this.toastr.error("Select Product Type !");
    }
  }

  public getMemberProductList(type) {
    if (type == "community" || type == "shout-out") {
      console.log("FETCH getMemberShopProductList 3")
      this.customerService
        .getMemberShopProductList({
          categoryId: "",
          subCategoryId: "",
          limit: 1002
        })
        .subscribe((response: any) => {

          this.productList = response.body.data.filter((i: any) => i.type == (type == "shout-out" ? 'promote' : "shop"));
        });
    } else {
      this.customerService.getBizProductList({}).subscribe((response: any) => {
        this.productList = response.body.data;
      });
    }
  }

  public attachProduct(productList: Array<any>) {
    this.selectedProduct = productList.filter((i) => i.checked);
  }

  public regionSplit(name: string): string {
    if (name && name.includes(",")) {
      let data = name.split(",");
      return `${data[0]}, ${data[1].trim().charAt(0)}`;
    } else {
      return name;
    }
  }
}
